import { Component, Input, SimpleChanges } from '@angular/core';

/**
 * Generated class for the SubmenuSelectionBoxComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'submenu-selection-box',
  templateUrl: 'submenu-selection-box.html'
})
export class SubmenuSelectionBoxComponent {

  @Input() subs: any;
  @Input() flowQtt: any;
  @Input() sequence: any;
  @Input() len: any;
  remining: number;
  max: number;
  drawempty: any;

  constructor() {
  }

  ngOnInit(){
    var max = (this.subs[0].required) ? 1 : parseInt(this.subs[0].parent_max, 0);
    var len = (this.sequence) ? this.sequence.length : 0;
    this.remining = max - len;
    this.max = max;
    this.drawempty = [];
    for (let i=0; i<this.remining; i++){
      this.drawempty.push(1);
    }
  }
  ngOnChanges(changes:SimpleChanges){
    console.log("CHANGE");
    var max = (this.subs[0].required) ? 1 : parseInt(this.subs[0].parent_max, 0);
    var len = (this.sequence) ? this.sequence.length : 0;
    this.remining = max - len;
    this.max = max;
    this.drawempty = [];
    for (let i=0; i<this.remining; i++){
      this.drawempty.push(1);
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/submenu-selection-box/submenu-selection-box.ts